(function(){
  'use strict';
  if(window.__loviPdpInit){ return; }
  window.__loviPdpInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
  /* Config panier (surchargable via window.LOVI_CART_CONFIG défini en Liquid) */
  var CART_CFG = window.LOVI_CART_CONFIG || {};
  var RESERVE_SECS = CART_CFG.reserveSeconds || 600;      /* compte à rebours : 10 min */
  function money(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' €'; }
  function syncBadge(count){
    document.querySelectorAll('.m-cart-count, .m-cart-count-bubble').forEach(function(b){ b.textContent = count; });
  }
  /* Saut d'ancre fiable (le smooth natif du thème est trop lent) */
  function jumpTo(el){
    var prev = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    var y = el.getBoundingClientRect().top + window.pageYOffset - 8;
    window.scrollTo(0, y);
    document.documentElement.style.scrollBehavior = prev;
  }
  /* Résout une ancre même si Shopify a préfixé l'id de section (template--xxx__offer) */
  function resolveTarget(href){
    if(!href || href.charAt(0) !== '#') return null;
    var t = null;
    try { t = document.querySelector(href); } catch(e){}
    if(t) return t;
    var m = href.match(/^#shopify-section-(.+)$/);
    if(m){
      t = document.querySelector('.shopify-section[id$="__' + m[1] + '"]') || document.querySelector('.shopify-section[id*="' + m[1] + '"]');
      if(t) return t;
    }
    var plain = href.slice(1);
    t = document.querySelector('.shopify-section[id$="__' + plain + '"]');
    if(t) return t;
    if(/offer|produit|buybox|acheter/i.test(href)){ return document.querySelector('[data-lpdp-buybox]'); }
    return null;
  }

  /* ---------- Upsells panier ("Complétez votre rituel") ---------- */
  /* Uniquement la brosse de drainage (24,90€ à l'unité, offerte dès le bundle 3 flacons) */
  var UPSELL_HANDLES = ['brosse-drainage-lymphatique-visage-offerte'];
  var upsellCache = null;
  function loadUpsells(){
    if(upsellCache) return Promise.resolve(upsellCache);
    return Promise.all(UPSELL_HANDLES.map(function(h){
      return fetch(ROOT + 'products/' + h + '.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    })).then(function(list){
      upsellCache = list.filter(Boolean).filter(function(p){ return p.available; });
      return upsellCache;
    });
  }

  /* ---------- Prix barrés (compare_at) ---------- */
  var compareCache = {};
  function fetchCompares(items){
    var handles = {};
    items.forEach(function(it){ if(it.handle && compareCache[it.variant_id] === undefined){ handles[it.handle] = true; } });
    var list = Object.keys(handles);
    if(!list.length) return Promise.resolve();
    return Promise.all(list.map(function(h){
      return fetch(ROOT + 'products/' + h + '.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){ if(p && p.variants){ p.variants.forEach(function(v){ compareCache[v.id] = v.compare_at_price || 0; }); } })
        .catch(function(){});
    }));
  }

  /* ---------- Panier latéral ---------- */
  var drawerEl = null, overlayEl = null, timerInt = null;
  function startTimer(){
    var tEl = drawerEl ? drawerEl.querySelector('[data-drawer-timer]') : null;
    if(!tEl) return;
    var end = 0;
    try { end = parseInt(sessionStorage.getItem('lovi_cart_reserve_end') || '0', 10); } catch(e){}
    var now = Math.floor(Date.now()/1000);
    if(!end || end <= now){
      end = now + RESERVE_SECS;
      try { sessionStorage.setItem('lovi_cart_reserve_end', String(end)); } catch(e){}
    }
    function tick(){
      var left = end - Math.floor(Date.now()/1000);
      if(left <= 0){
        end = Math.floor(Date.now()/1000) + RESERVE_SECS;
        try { sessionStorage.setItem('lovi_cart_reserve_end', String(end)); } catch(e){}
        left = RESERVE_SECS;
      }
      var mn = Math.floor(left/60), sc = left % 60;
      tEl.textContent = (mn < 10 ? '0' : '') + mn + ':' + (sc < 10 ? '0' : '') + sc;
    }
    if(timerInt) clearInterval(timerInt);
    timerInt = setInterval(tick, 1000);
    tick();
  }
  function buildDrawer(){
    if(drawerEl) return;
    var st = document.createElement('style');
    st.textContent = '.lovi-drawer__price{text-align:right;display:flex;flex-direction:column;align-items:flex-end;gap:2px}' +
      '.lovi-drawer__compare{font-size:.8em;color:#9A958B;text-decoration:line-through;font-weight:400}' +
      '.lovi-drawer__totals{border-top:1px dashed #ABB2A4;padding-top:8px;margin-bottom:2px}' +
      '.lovi-drawer__row{display:flex;justify-content:space-between;align-items:center;margin:0 0 8px;font-size:.92rem;color:#383838}' +
      '.lovi-drawer__total{display:flex;justify-content:space-between;align-items:flex-start;margin:0;font-size:.98rem;font-weight:700;color:#2F4A44}' +
      '.lovi-drawer__total-label{display:flex;flex-direction:column;gap:1px}' +
      '.lovi-drawer__taxes-note{font-size:.7rem;color:#9A958B;font-weight:400}' +
      '.lovi-drawer__total-line{display:flex;flex-direction:column;align-items:flex-end;gap:2px}' +
      '.lovi-drawer__total-compare{font-size:.78em;color:#9A958B;text-decoration:line-through;font-weight:400}' +
      '.lovi-drawer__urgency{background:#2F4A44;color:#fff;text-align:center;font-size:.85rem;padding:9px 14px;letter-spacing:.02em}' +
      '.lovi-drawer__urgency strong{font-variant-numeric:tabular-nums}' +
      '.lovi-drawer__ship{padding:12px 20px 4px}' +
      '.lovi-drawer__ship-label{margin:0 0 7px;font-size:.85rem;font-weight:600;color:#2F4A44;text-align:center}' +
      '.lovi-drawer__ship-label.is-unlocked{color:#2E8B57}' +
      '.lovi-drawer__ship-track{height:8px;border-radius:99px;background:#EBE7DC;overflow:hidden}' +
      '.lovi-drawer__ship-fill{height:100%;border-radius:99px;background:#4CAF7D;transition:width .4s ease}' +
      '.lovi-drawer__reassure-line{margin:9px 0 0;font-size:clamp(9px,2.4vw,10.5px);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#3C4A44;text-align:center;font-weight:600;line-height:1.3}' +
      '.lovi-drawer__payments{display:flex;justify-content:center;align-items:center;gap:6px;margin:8px 0 0;flex-wrap:nowrap;max-width:100%}' +
      '.lovi-drawer__payments svg,.lovi-drawer__payments img{height:16px;width:auto;max-width:30px;display:block;flex:0 0 auto}' +
      '.lovi-drawer__note{margin:8px 0 0;font-size:clamp(9px,2.4vw,10.5px);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#7A8680;text-align:center;line-height:1.3}' +
      '.lovi-drawer__upsell{padding:14px 20px 4px;border-top:1px solid #ECE6DA}' +
      '.lovi-drawer__upsell-title{display:flex;align-items:center;gap:6px;margin:0 0 10px;font-family:\'Fraunces\',sans-serif;font-weight:700;font-size:12.5px;color:#2F4A44}' +
      '.lovi-drawer__upsell-title .ic{color:#B87F6A;font-size:13px}' +
      '.lovi-drawer__upsell-row{display:flex;gap:10px;overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;padding-bottom:4px}' +
      '.lovi-drawer__upsell-row::-webkit-scrollbar{display:none}' +
      '.lovi-drawer__upsell-card{position:relative;flex:0 0 108px;background:#F2F3EE;border:1px solid #ECE6DA;border-radius:12px;padding:8px 8px 10px;text-align:center}' +
      '.lovi-drawer__upsell-card img{width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:8px;display:block;margin:0 0 6px;background:#fff}' +
      '.lovi-drawer__upsell-name{font-size:10.5px;font-weight:600;color:#2F3B35;line-height:1.25;margin:0 0 4px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
      '.lovi-drawer__upsell-price{font-size:10.5px;font-weight:700;color:#2F4A44;margin:0}' +
      '.lovi-drawer__upsell-add{position:absolute;top:6px;right:6px;width:22px;height:22px;border-radius:50%;background:#2F4A44;color:#fff;border:none;font-size:15px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0}' +
      '.lovi-drawer__upsell-add:disabled{opacity:.5}' +
      '.lovi-drawer__upsell-add.is-added{background:#B87F6A}';
    document.head.appendChild(st);
    overlayEl = document.createElement('div');
    overlayEl.className = 'lovi-drawer-overlay';
    drawerEl = document.createElement('aside');
    drawerEl.className = 'lovi-drawer';
    drawerEl.setAttribute('role','dialog');
    drawerEl.setAttribute('aria-label','Votre panier');
    drawerEl.innerHTML = '<div class="lovi-drawer__head"><p class="lovi-drawer__title">Votre panier</p><button type="button" class="lovi-drawer__close" aria-label="Fermer">✕</button></div>' +
      '<div class="lovi-drawer__urgency" data-drawer-urgency>Votre commande est réservée pendant <strong data-drawer-timer>10:00</strong> ⏰</div>' +
      '<div class="lovi-drawer__ship" data-drawer-ship style="display:none"><p class="lovi-drawer__ship-label" data-drawer-ship-label></p><div class="lovi-drawer__ship-track"><div class="lovi-drawer__ship-fill" data-drawer-ship-fill style="width:0%"></div></div></div>' +
      '<div class="lovi-drawer__items" data-drawer-items></div>' +
      '<div class="lovi-drawer__upsell" data-drawer-upsell style="display:none"><p class="lovi-drawer__upsell-title"><span class="ic" aria-hidden="true">✨</span>Complétez votre rituel :</p><div class="lovi-drawer__upsell-row" data-drawer-upsell-row></div></div>' +
      '<div class="lovi-drawer__foot">' +
      '<div class="lovi-drawer__totals">' +
      '<p class="lovi-drawer__total"><span class="lovi-drawer__total-label">Total<span class="lovi-drawer__taxes-note">Taxes incluses</span></span><span class="lovi-drawer__total-line"><s class="lovi-drawer__total-compare" data-drawer-total-compare style="display:none"></s><span data-drawer-total>—</span></span></p>' +
      '</div>' +
      '<button type="button" class="lovi-btn lovi-btn--full" data-drawer-checkout>COMMANDER <span class="lovi-btn__arrow">→</span></button>' +
      '<p class="lovi-drawer__reassure-line">🚚 Expédié sous 48h garanti · Satisfait ou remboursé 30 jours</p>' +
      '<div class="lovi-drawer__payments" data-drawer-payments></div>' +
      '<p class="lovi-drawer__note">🔒 Paiement 100% sécurisé · 🇫🇷 Expédié depuis la France</p></div>';
    document.body.appendChild(overlayEl);
    document.body.appendChild(drawerEl);
    /* Logos de paiement : réutilise ceux déjà rendus par Liquid (rendu réel Shopify des moyens de paiement actifs), */
    /* mais on ne garde qu'une sélection courte et connue pour rester propre et tenir sur une ligne */
    var paySrc = document.querySelector('.lpdp-payments, .lovi-payments');
    if(paySrc){
      var PAY_ALLOWED = ['visa','master','mastercard','american_express','amex','paypal','apple_pay','applepay','klarna'];
      var PAY_MAX = 5;
      var allSvgs = Array.prototype.slice.call(paySrc.querySelectorAll('svg'));
      var keptSvgs = [];
      allSvgs.forEach(function(svg){
        if(keptSvgs.length >= PAY_MAX) return;
        var titleEl = svg.querySelector('title');
        var label = ((titleEl && titleEl.textContent) || svg.getAttribute('aria-label') || svg.getAttribute('class') || '').toLowerCase().replace(/[\s-]/g, '_');
        var ok = PAY_ALLOWED.some(function(k){ return label.indexOf(k) > -1; });
        if(ok){ keptSvgs.push(svg); }
      });
      if(!keptSvgs.length){ keptSvgs = allSvgs.slice(0, PAY_MAX); }
      var payTarget = drawerEl.querySelector('[data-drawer-payments]');
      keptSvgs.forEach(function(svg){ payTarget.appendChild(svg.cloneNode(true)); });
    }
    overlayEl.addEventListener('click', closeDrawer);
    drawerEl.querySelector('.lovi-drawer__close').addEventListener('click', closeDrawer);
    drawerEl.querySelector('[data-drawer-checkout]').addEventListener('click', function(){ window.location.href = ROOT + 'checkout'; });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });
  }
  function renderCart(cart){
    buildDrawer();
    fetchCompares(cart.items || []).then(function(){ renderCartNow(cart); });
  }
  function renderUpsells(){
    var box = drawerEl.querySelector('[data-drawer-upsell]');
    var row = drawerEl.querySelector('[data-drawer-upsell-row]');
    if(!box || !row) return;
    if(row.getAttribute('data-populated')){ box.style.display = ''; return; }
    loadUpsells().then(function(products){
      if(!products || !products.length) return;
      row.setAttribute('data-populated', '1');
      row.innerHTML = products.map(function(p){
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_200x$1$2') : '';
        var v = p.variants && p.variants[0];
        var price = v ? money(v.price) : '';
        return '<div class="lovi-drawer__upsell-card">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          '<p class="lovi-drawer__upsell-name">' + p.title + '</p>' +
          '<p class="lovi-drawer__upsell-price">' + price + '</p>' +
          '<button type="button" class="lovi-drawer__upsell-add" data-upsell-variant="' + (v ? v.id : '') + '" aria-label="Ajouter ' + p.title + '">+</button>' +
          '</div>';
      }).join('');
      row.querySelectorAll('[data-upsell-variant]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var vid = btn.getAttribute('data-upsell-variant');
          if(!vid) return;
          btn.disabled = true;
          fetch(ROOT + 'cart/add.js', {
            method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
          }).then(function(r){ return r.json(); }).then(function(){
            btn.classList.add('is-added');
            btn.textContent = '✓';
            refreshDrawer();
          }).catch(function(){ btn.disabled = false; });
        });
      });
      box.style.display = '';
    });
  }
  function renderCartNow(cart){
    var wrap = drawerEl.querySelector('[data-drawer-items]');
    var totalEl = drawerEl.querySelector('[data-drawer-total]');
    var totalCompareEl = drawerEl.querySelector('[data-drawer-total-compare]');
    var checkoutBtn = drawerEl.querySelector('[data-drawer-checkout]');
    var urgency = drawerEl.querySelector('[data-drawer-urgency]');
    var ship = drawerEl.querySelector('[data-drawer-ship]');
    var shipLabel = drawerEl.querySelector('[data-drawer-ship-label]');
    var shipFill = drawerEl.querySelector('[data-drawer-ship-fill]');
    syncBadge(cart.item_count || 0);
    if(!cart.items || !cart.items.length){
      wrap.innerHTML = '<p class="lovi-drawer__empty">Votre panier est vide.<br>Choisissez votre cure pour commencer.</p>';
      totalEl.textContent = money(0);
      totalCompareEl.style.display = 'none';
      checkoutBtn.style.display = 'none';
      if(urgency) urgency.style.display = 'none';
      if(ship) ship.style.display = 'none';
      return;
    }
    checkoutBtn.style.display = '';
    if(urgency){ urgency.style.display = ''; startTimer(); }
    /* Barre livraison offerte (inconditionnelle, pour toute commande) */
    if(ship && shipLabel && shipFill){
      ship.style.display = '';
      shipFill.style.width = '100%';
      shipLabel.textContent = '✅ Livraison offerte';
      shipLabel.classList.add('is-unlocked');
    }
    var html = '';
    var totalCompare = 0;
    cart.items.forEach(function(it){
      var isGift = it.final_line_price === 0;
      var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_140x$1$2') : '';
      var compare = compareCache[it.variant_id] || 0;
      var lineCompare;
      if(isGift){ lineCompare = Math.max(compare * it.quantity, it.original_line_price || 0); }
      else { lineCompare = Math.max(compare * it.quantity, it.original_line_price || 0, it.final_line_price); }
      totalCompare += lineCompare;
      var priceHtml;
      if(isGift){ priceHtml = (lineCompare > 0 ? '<s class="lovi-drawer__compare">' + money(lineCompare) + '</s>' : '') + 'OFFERT'; }
      else { priceHtml = (lineCompare > it.final_line_price ? '<s class="lovi-drawer__compare">' + money(lineCompare) + '</s>' : '') + money(it.final_line_price); }
      html += '<div class="lovi-drawer__item">' +
        (img ? '<img class="lovi-drawer__img" src="' + img + '" alt="" loading="lazy">' : '<span class="lovi-drawer__img"></span>') +
        '<div class="lovi-drawer__info"><p class="lovi-drawer__name">' + it.product_title + '</p>' +
        '<p class="lovi-drawer__meta">Qté ' + it.quantity + (isGift ? ' · Cadeau inclus' : '') + '</p>' +
        (isGift ? '' : '<button type="button" class="lovi-drawer__remove" data-remove-key="' + it.key + '">Retirer</button>') +
        '</div>' +
        '<span class="lovi-drawer__price' + (isGift ? ' is-gift' : '') + '">' + priceHtml + '</span>' +
        '</div>';
    });
    wrap.innerHTML = html;
    renderUpsells();
    totalEl.textContent = money(cart.total_price);
    if(totalCompare > cart.total_price){
      totalCompareEl.textContent = money(totalCompare);
      totalCompareEl.style.display = '';
    } else {
      totalCompareEl.style.display = 'none';
    }
    wrap.querySelectorAll('[data-remove-key]').forEach(function(btn){
      btn.addEventListener('click', function(){
        btn.disabled = true;
        fetch(ROOT + 'cart/change.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: btn.getAttribute('data-remove-key'), quantity: 0 })
        }).then(function(r){ return r.json(); }).then(renderCart).catch(function(){ btn.disabled = false; });
      });
    });
  }
  function refreshDrawer(){
    return fetch(ROOT + 'cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(renderCart);
  }
  function openDrawer(){
    buildDrawer();
    refreshDrawer().then(function(){
      overlayEl.classList.add('is-open');
      drawerEl.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeDrawer(){
    if(!drawerEl) return;
    overlayEl.classList.remove('is-open');
    drawerEl.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* Clic panier header → drawer LOVI (navigation normale conservée ailleurs) */
  document.addEventListener('click', function(e){
    var el = e.target.closest ? e.target.closest('a, button') : null;
    if(!el) return;
    if(!el.closest('.shopify-section-group-header-group, #shopify-section-header, header, .m-header')) return;
    var href = (el.getAttribute('href') || '');
    var label = ((el.getAttribute('aria-label') || '') + ' ' + String(el.className || '')).toLowerCase();
    if(href.indexOf('/cart') > -1 || label.indexOf('cart') > -1 || label.indexOf('panier') > -1){
      e.preventDefault(); e.stopPropagation();
      openDrawer();
    }
  }, true);

  function ready(fn){ if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', fn); } else { fn(); } }

  ready(function(){

  /* ---------- Date "livraison offerte jusqu'au …" : recalculée chaque jour, jamais figée ---------- */
  (function(){
    var els = document.querySelectorAll('[data-lovi-shipdate]');
    if(!els.length) return;
    var d = new Date();
    d.setDate(d.getDate() + 3);
    var txt;
    try { txt = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long' }).format(d); }
    catch(e){ txt = d.toLocaleDateString('fr-FR'); }
    els.forEach(function(el){ el.textContent = txt; });
  })();

  /* ---------- Galerie : vignettes + flèches + swipe ---------- */
  document.querySelectorAll('[data-lpdp-gallery]').forEach(function(g){
    var main = g.querySelector('[data-lpdp-main]');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-lpdp-thumb]'));
    if(!main || !thumbs.length) return;
    var idx = 0;
    function show(i){
      idx = (i + thumbs.length) % thumbs.length;
      var img = thumbs[idx].querySelector('img');
      if(img){ main.src = img.getAttribute('data-full') || img.src; main.alt = img.alt || ''; }
      thumbs.forEach(function(x,k){ x.classList.toggle('is-active', k === idx); });
    }
    thumbs.forEach(function(t,k){ t.addEventListener('click', function(){ show(k); }); });
    g.querySelectorAll('[data-lpdp-galprev]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); show(idx-1); }); });
    g.querySelectorAll('[data-lpdp-galnext]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); show(idx+1); }); });
    var zone = g.querySelector('.lpdp-gallery__main') || main;
    var x0 = null, y0 = null;
    zone.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, {passive:true});
    zone.addEventListener('touchend', function(e){
      if(x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){ if(dx < 0){ show(idx+1); } else { show(idx-1); } }
      x0 = null; y0 = null;
    }, {passive:true});
  });

  /* ---------- Buy box : packs + cadeaux + ATC ---------- */
  document.querySelectorAll('[data-lpdp-buybox]').forEach(function(root){
    var packs = root.querySelectorAll('[data-lpdp-pack]');
    var gifts = root.querySelectorAll('[data-lpdp-gift]');
    var atc = root.querySelector('[data-lpdp-atc]');
    var atcPrice = root.querySelector('[data-lpdp-atc-price]');
    var sticky = document.querySelector('[data-lpdp-sticky]');
    var stickyPrice = sticky ? sticky.querySelector('[data-lpdp-sticky-price]') : null;
    var stickyBtn = sticky ? sticky.querySelector('[data-lpdp-sticky-atc]') : null;
    var current = null;
    function select(p){
      packs.forEach(function(o){ o.classList.remove('is-selected'); });
      p.classList.add('is-selected');
      current = p;
      var unlock = parseInt(p.getAttribute('data-unlock') || '0', 10);
      gifts.forEach(function(gf){
        var lvl = parseInt(gf.getAttribute('data-level') || '1', 10);
        gf.classList.toggle('is-locked', lvl > unlock);
      });
      var price = p.getAttribute('data-price-text') || '';
      var compare = p.getAttribute('data-compare-text') || '';
      if(atcPrice){ atcPrice.textContent = price ? ' — ' + price : ''; }
      if(stickyPrice){ stickyPrice.innerHTML = price + (compare ? '<s>' + compare + '</s>' : ''); }
    }
    packs.forEach(function(p){
      p.addEventListener('click', function(){ select(p); });
      p.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); select(p); } });
    });
    var def = root.querySelector('[data-lpdp-pack][data-default]') || packs[0];
    if(def) select(def);

    function addToCart(){
      if(!current) return;
      var vid = current.getAttribute('data-variant-id');
      if(!vid) return;
      var items = [{ id: parseInt(vid, 10), quantity: 1 }];
      var giftIds = current.getAttribute('data-gifts');
      if(giftIds){
        giftIds.split(',').forEach(function(g){ g = g.trim(); if(g && g !== '0') items.push({ id: parseInt(g, 10), quantity: 1 }); });
      }
      var btns = [atc, stickyBtn].filter(Boolean);
      btns.forEach(function(b){ b.setAttribute('aria-busy','true'); b.style.opacity = '.7'; });
      fetch(ROOT + 'cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items: items })
      }).then(function(r){ if(!r.ok) throw new Error('atc'); return r.json(); })
      .then(function(){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
        openDrawer();
      })
      .catch(function(){ window.location.href = ROOT + 'cart/add?id=' + vid + '&quantity=1'; })
      .finally(function(){ btns.forEach(function(b){ b.removeAttribute('aria-busy'); b.style.opacity = ''; }); });
    }
    if(atc) atc.addEventListener('click', addToCart);
    if(stickyBtn) stickyBtn.addEventListener('click', addToCart);

    if(sticky && atc){
      var onScroll = function(){
        var r = atc.getBoundingClientRect();
        sticky.classList.toggle('is-visible', r.bottom < 0);
      };
      window.addEventListener('scroll', onScroll, {passive:true});
      onScroll();
    }
  });

  /* ---------- Marquee mini-avis : duplication pour boucle ---------- */
  document.querySelectorAll('[data-lpdp-marquee]').forEach(function(m){
    var track = m.querySelector('.lpdp-marquee__track');
    if(track && !track.getAttribute('data-cloned')){
      track.innerHTML += track.innerHTML;
      track.setAttribute('data-cloned','1');
    }
  });

  /* ---------- Accordéons (produit + FAQ) ---------- */
  document.querySelectorAll('[data-lpdp-acc]').forEach(function(group){
    group.querySelectorAll('.lpdp-acc__item').forEach(function(item){
      var q = item.querySelector('.lpdp-acc__q');
      var a = item.querySelector('.lpdp-acc__a');
      if(!q || !a) return;
      q.addEventListener('click', function(){
        var open = item.classList.contains('is-open');
        group.querySelectorAll('.lpdp-acc__item.is-open').forEach(function(o){
          o.classList.remove('is-open');
          o.querySelector('.lpdp-acc__a').style.maxHeight = null;
        });
        if(!open){ item.classList.add('is-open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  });
  document.querySelectorAll('[data-lpdp-faq] .lovi-faq__item').forEach(function(item){
    var q = item.querySelector('.lovi-faq__q');
    var a = item.querySelector('.lovi-faq__a');
    if(!q || !a) return;
    q.addEventListener('click', function(){
      var open = item.classList.contains('is-open');
      item.closest('[data-lpdp-faq]').querySelectorAll('.lovi-faq__item.is-open').forEach(function(o){
        o.classList.remove('is-open');
        o.querySelector('.lovi-faq__a').style.maxHeight = null;
      });
      if(!open){ item.classList.add('is-open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });

  /* ---------- Slider avant/après ---------- */
  document.querySelectorAll('[data-lpdp-ba]').forEach(function(ba){
    var after = ba.querySelector('.lpdp-ba__after');
    var handle = ba.querySelector('.lpdp-ba__handle');
    if(!after || !handle) return;
    function setPos(clientX){
      var r = ba.getBoundingClientRect();
      var x = Math.min(Math.max(clientX - r.left, 0), r.width);
      var pct = (x / r.width) * 100;
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }
    var dragging = false;
    ba.addEventListener('pointerdown', function(e){ dragging = true; ba.setPointerCapture(e.pointerId); setPos(e.clientX); });
    ba.addEventListener('pointermove', function(e){ if(dragging) setPos(e.clientX); });
    ba.addEventListener('pointerup', function(){ dragging = false; });
    ba.addEventListener('pointercancel', function(){ dragging = false; });
  });

  /* ---------- Avis : voir plus ---------- */
  document.querySelectorAll('[data-lpdp-more]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var wrap = document.querySelector(btn.getAttribute('data-target'));
      if(wrap){ wrap.querySelectorAll('.lpdp-review.is-hidden').forEach(function(r){ r.classList.remove('is-hidden'); }); }
      btn.style.display = 'none';
    });
  });

  /* ---------- Ancres : saut direct fiable + ids Shopify préfixés ---------- */
  document.querySelectorAll('a[data-lpdp-scroll]').forEach(function(a){
    a.addEventListener('click', function(e){
      var t = resolveTarget(a.getAttribute('href'));
      if(t){ e.preventDefault(); jumpTo(t); }
    });
  });

  /* ---------- Bulles vidéo : lecture en vue + modal plein écran ---------- */
  (function(){
    var bubbles = document.querySelectorAll('[data-lovi-bubble]');
    if(!bubbles.length) return;
    if('IntersectionObserver' in window){
      var vio = new IntersectionObserver(function(es){
        es.forEach(function(en){
          var v = en.target.querySelector('video');
          if(!v) return;
          if(en.isIntersecting){ v.muted = true; var p = v.play(); if(p && p.catch) p.catch(function(){}); }
          else { v.pause(); }
        });
      }, {rootMargin:'60px'});
      bubbles.forEach(function(b){ vio.observe(b); });
    }
    var overlay = null;
    function closeModal(){
      if(!overlay) return;
      var mv = overlay.querySelector('video');
      if(mv) mv.pause();
      overlay.remove(); overlay = null;
      document.body.style.overflow = '';
    }
    function srcOf(b){
      var s = b.querySelector('video source[type*="mp4"]') || b.querySelector('video source');
      if(s && s.src) return s.src;
      var v = b.querySelector('video');
      return v ? (v.currentSrc || v.src || '') : '';
    }
    bubbles.forEach(function(b){
      b.addEventListener('click', function(){
        var src = srcOf(b);
        if(!src) return;
        overlay = document.createElement('div');
        overlay.className = 'lovi-bubble-modal';
        overlay.innerHTML = '<div class="lovi-bubble-modal__bg"></div>' +
          '<div class="lovi-bubble-modal__box"><button type="button" class="lovi-bubble-modal__x" aria-label="Fermer">✕</button>' +
          '<video src="' + src + '" controls autoplay playsinline></video></div>';
        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';
        overlay.querySelector('.lovi-bubble-modal__bg').addEventListener('click', closeModal);
        overlay.querySelector('.lovi-bubble-modal__x').addEventListener('click', closeModal);
      });
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeModal(); });
  })();

  /* ---------- Reveal (robuste : ne rate jamais une section) ---------- */
  (function(){
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-lpdp-reveal]'));
    if(!els.length) return;
    els.forEach(function(el){
      el.style.opacity = 0; el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity .6s ease, transform .6s ease';
    });
    function check(){
      var vh = window.innerHeight || document.documentElement.clientHeight;
      els = els.filter(function(el){
        var r = el.getBoundingClientRect();
        if(r.top < vh * 0.95 || r.bottom < vh){
          el.style.opacity = 1; el.style.transform = 'none';
          return false;
        }
        return true;
      });
      if(!els.length){
        window.removeEventListener('scroll', check);
        window.removeEventListener('resize', check);
      }
    }
    window.addEventListener('scroll', check, {passive:true});
    window.addEventListener('resize', check, {passive:true});
    window.addEventListener('load', check);
    check();
  })();

  }); /* ready */
})();
